import styled from 'styled-components';

const CommonDiv = styled.div`
  font-family: 'HelveticaNeue', 'Helvetica Neue', 'Helvetica', 'SF Pro Text', 'Arial', sans-serif;
  font-size: ${props => props.size || 1}em;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: ${props => props.align || 'center'};
  color: ${props => props.color || props.theme.color.text};
  margin-top: ${props => props.mt}em;
  margin-bottom: ${props => props.mb};
  margin: ${props => props.m};
  padding-left: ${props => props.px};
  padding-right: ${props => props.px};
`;

const InputLabel = styled(CommonDiv)`
  color: ${props => props.theme.color.label};
  font-size: ${props => props.size || 0.875}em;
  text-align: left;
  margin-top: ${props => props.top || 0}rem;
`;

const Required = styled.span`
  color: ${props => props.theme.color.error};
`;

const ButtonBlock = styled.div`
  width: 100%;
  margin-top: 2.5em;
  text-align: center;
  position: relative;
  @media all and (max-width: 576px) {
    margin-top: 1.5em;
  }
`;

const ContinueButton = styled.button`
  outline: none;
  padding: 0.667em 3.056em;
  border: 0;
  font-family: 'HelveticaNeue', 'Helvetica Neue';
  font-size: 1.125em;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  border-radius: 6px;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  background-color: ${props =>
    props.disabled ? props.theme.color.disabled : props.theme.color.primary};
`;

export { CommonDiv, InputLabel, Required, ButtonBlock, ContinueButton };
